import { computed, inject, provide } from 'vue';

export const FormFieldInjectionKey = Symbol('frontplane.form-field');
export const InputIdInjectionKey = Symbol('frontplane.input-id');

export const useFormField = (props, opts = undefined) => {
    const formField = inject(FormFieldInjectionKey, undefined);
    const inputId = inject(InputIdInjectionKey, undefined);

    // Blocks the FormField injection to avoid duplicating events when nesting input components.
    provide(FormFieldInjectionKey, undefined);

    if (formField && inputId) {
        if (opts?.bind === false) {
            // Removes for="..." attribute on label for RadioGroup and alike.
            inputId.value = undefined;
        } else if (props?.id) {
            // Updates for="..." attribute on label if props.id is provided.
            inputId.value = props?.id;
        }
    }

    return {
        id: computed(() => props?.id ?? inputId?.value),
        name: computed(() => props?.name ?? formField?.value.name),
        error: computed(() => (formField?.value.error ? true : props?.error)),
        required: computed(() => props?.required ?? formField?.value.required),
    };
};
